// extracted by mini-css-extract-plugin
export default {"container":"PatternsRoot_container__ka72Z"};